import { GET } from '../utils/request.js';
import { getTpDataSign } from '../utils/rsa.js';
let apiConfig = null;
try {
  apiConfig = require('../../src/config/api').default;
} catch (e) {
  // 文件不存在时忽略错误
}
const giamCommon = apiConfig?.VUE_APP_GIAM_Common || process.env.VUE_APP_GIAM_Common;

const defaultConfig = {
  baseURL: giamCommon,
  withCredentials: false,
};
export function getMulLogList(params, needSign) {
  let headers = {};
  if (needSign) {
    headers = getTpDataSign(params);
  }
  return GET('/log/selectLogByPage', params, { ...defaultConfig, headers: { ...headers } });
}


